import { useEffect } from "react";
import dayjs from "dayjs";
import { documentService } from "../../services";
import { IDocument } from "../../customTypings/document/Document";
import { IFolder } from "../../customTypings/document/Folder";

export const useDocumentData = (
  baseFolder: boolean,
  taskId: string | undefined,
  currentFolder: IFolder | undefined,
  setFolders: (folders: IFolder[]) => void,
  setDocuments: (documents: IDocument[]) => void,
  setIsLoading: (loading: boolean) => void,
  setAlertMessage: (message: string) => void,
  setHasParentFolder: (hasParent: boolean) => void
) => {
  const getFoldersAndDocuments = (taskId?: string, currentFolderId?: string) => {
    setIsLoading(true);

    Promise.all([
      documentService.getFolders(taskId, currentFolderId),
      documentService.getDocuments(currentFolderId),
    ])
      .then((response) => {
        setFolders((response[0].results as IFolder[]) || []);
        const documents = response[1].results
          .filter((d: any) => d.entityId === taskId)
          .map((d: IDocument) => {
            const dateAdded = dayjs(d.dateAdded);
            d.dateAdded = dateAdded.format("DD/MM/YYYY HH:mm");
            return d;
          });

        setDocuments((documents as IDocument[]) || []);
        setIsLoading(false);
      })
      .catch((rejected) => {
        setAlertMessage(
          "Could not retrieve list of folders and documents: " + rejected
        );
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if ((baseFolder || taskId) && currentFolder) {
      setAlertMessage("");
      setHasParentFolder((currentFolder.parentFolderId?.length ?? 0) !== 0);
      getFoldersAndDocuments(taskId, currentFolder.id);
    }
  }, [baseFolder, taskId, currentFolder, setAlertMessage, setHasParentFolder]);

  const refresh = () => {
    if ((baseFolder || taskId) && currentFolder) {
      getFoldersAndDocuments(taskId, currentFolder.id);
    }
  };

  return {
    getFoldersAndDocuments,
    refresh,
  };
};
